/** 售后服务一级目录（990380）；二级：运维管理 / 售后支持 / 设备自动售后 — patch 116 恢复 */
export const AFTER_SALES_SERVICE_MENU_IDS = {
  root: 990380,
  maintenanceGroup: 1721413909706964992,
  supportTicketGroup: 990320,
  deviceServiceGroup: 990350
}



// WEBPACK FOOTER //
// ./src/constants/afterSalesService.js